import React from "react";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";
import ArtistList from "./ArtistList";

interface Props {
  selectedArtists: server.dto.ArtistSmall[]
  onChange: (newArtists: server.dto.ArtistSmall[]) => void
  securityScope: server.dto.ArtistSecurityScopes
}

const ArtistMultiPicker = (props: Props) => {

  return <MultiPickerSelectedItems
    selectedItems={props.selectedArtists}
    onRemove={props.onChange}
    getId={artist => artist.artistId}
    getLabel={artist => <div>
      {artist.name}
    </div>}
  >
    <ArtistList
      onItemSelected={(item) => props.onChange([...props.selectedArtists, item])}
      excludeKeys={props.selectedArtists.map(cc => cc.artistId)}
      securityScope={props.securityScope}
    />
  </MultiPickerSelectedItems>;
};

export default ArtistMultiPicker;